import React, {useEffect, useRef, useState} from "react";
import {useHistory} from "react-router";
import jsQR from 'jsqr'
import MButton from "@/components/atom/MButton";
import style from './Uketori.scss'
import useInterval from "@/util/useInterval";
import Layout from "@/layout/Layout";

const [webEndPoint] = [process.env.REACT_APP_WEB_ENDPOINT]

/**
 * 受取QR撮影ページ
 */
const UketoriQRPage = () => {
  const history = useHistory()
  const canvasRef = useRef(null);
  const [context, setContext] = useState(null)
  const [video, setVideo] = useState(null)

  useEffect(() => {
    (async () => {
    })()
  }, [])

  useInterval(() => {
    startTick()
  }, 250, () => {
    clearVideo()
  })

  const clearVideo = () => {
    if (video === null) {
      return
    }
    if (video.srcObject === null) {
      return
    }
    video.srcObject.getTracks().forEach((t) => { t.stop() })
    video.srcObject = null
    setVideo(null)
  }

  const startTick = () => {
    if (video === null) {
      return
    }
    if(video.readyState !== video.HAVE_ENOUGH_DATA) {
      return
    }

    canvasRef.current.height = video.videoHeight;
    canvasRef.current.width = video.videoWidth;
    context.drawImage(video, 0, 0, canvasRef.current.width, canvasRef.current.height);

    const image = context.getImageData(0, 0, canvasRef.current.width, canvasRef.current.height);
    const code = jsQR(image.data, image.width, image.height, { inversionAttempts: 'dontInvert' });

    if (!code) {
      return
    }
    if (!code.data.startsWith(webEndPoint)) {
      return
    }
    clearVideo()
    history.push(code.data.replace(webEndPoint, ''))
  }

  useEffect(() => {
    (async () => {
      if (!canvasRef.current) {
        return
      }

      const video  = document.createElement("video");
      const context = canvasRef.current.getContext("2d");
      setVideo(video)
      setContext(context)

      const userMedia = {video: {facingMode: "environment"}};
      navigator.mediaDevices.getUserMedia(userMedia).then((stream)=>{
        video.srcObject = stream;
        video.setAttribute("playsinline", true);
        video.play();
      });
    })()
  }, [canvasRef])

  const toBack = () => {
    clearVideo()
    history.push(`/uketori`)
  }

  return (
    <>
      <Layout category={'UK'} title={'受取QR撮影'}>
        <div className={style.qrPage}>
          <h3>名刺RのQRを撮影してください。</h3>
          <MButton image={'back.png'} value={'戻る'} onClick={toBack}></MButton>
          <div className={style.qrContainer}>
            <canvas ref={canvasRef} className={style.qrCanvas}></canvas>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default UketoriQRPage
